import { render } from "./RoutedChat.vue?vue&type=template&id=2cf5ac90&ts=true"
import script from "./RoutedChat.vue?vue&type=script&lang=ts"
export * from "./RoutedChat.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__